import { render, staticRenderFns } from "./bind.vue?vue&type=template&id=d7a2c248&scoped=true"
import script from "./bind.vue?vue&type=script&lang=js"
export * from "./bind.vue?vue&type=script&lang=js"
import style0 from "./bind.vue?vue&type=style&index=0&id=d7a2c248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a2c248",
  null
  
)

export default component.exports